module.exports = __webpack_public_path__ + "static/media/mongolfiere.a7d2c841.jpg";